import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="search"
export default class extends Controller {
  static targets = ["fields"];

  connect() {}

  removeFields(event) {
    event.preventDefault();
    event.currentTarget.closest(".fields").remove();
  }

  addFields(event) {
    event.preventDefault();

    const type = event.currentTarget.dataset.fieldType;
    const content = event.currentTarget.dataset.content;

    let newId, regExp;
    newId = new Date().getTime();
    regExp = new RegExp("new_" + type, "g");

    this.fieldsTarget.insertAdjacentHTML(
      "beforeend",
      content.replace(regExp, newId)
    );
  }
}
